import React, { useContext, useState } from "react";
import { motion } from "framer-motion";

import pizza from "../assets/img/pizza.svg";
import displaySpicy from './utils/spicy'
import basketSvg from "../assets/icons/basket.svg";

import MyContext from "./Context/Context";

function Card({ data, displayPopupPizza }) {
  const { addToBasket, displayFlash, setFlashMessage } = useContext(MyContext);

  const { id, title, category, price, spicy } = data;


  const handleBasket = (item) => {
    setFlashMessage(item.title + " added");
    addToBasket(item);
    displayFlash();
  };

  const item = {
    hidden: { opacity: 0, y: -50 },
    show: { opacity: 1, y: 0 },
    transition: { ease: "easeInOut" },
  };


  return (
    <>
      <motion.li variants={item} className={`popular__item swiper-slide`}>
        <div onClick={() => displayPopupPizza(id)}>
          <div className="popular__card">
            <picture className="popular__pizza">
              <img src={pizza} alt="pizza" />
            </picture>
            <div className="popular__desc">
              <div className="spicy">
                {displaySpicy(spicy)}
                <div>
                  <span className="bold" style={{ textTransform: "capitalize" }}>
                    {title}
                  </span>
                  <div>{category}</div>
                </div>
              </div>
              <div className="price">$ {price}</div>
            </div>
          </div>
        </div>
        <div className="popular__wrapper__btn">
          <div className="popular__wrapper__btn__add" onClick={() => handleBasket(data)}>
            <img src={basketSvg} alt="basket" />
          </div>
        </div>
      </motion.li>
    </>
  );
}

export default Card;
